"use strict";
exports.__esModule = true;
exports.THEME_CONFIG_FRAGMENT = void 0;
var EXTENSIONS_FRAGMENT = "\nextensions {\n  name\n  size\n  variant\n  colorScheme\n  defaultProps {\n    size\n    variant\n    colorScheme\n  }\n  components\n}\n";
exports.THEME_CONFIG_FRAGMENT = "\n  themeConfig {\n    themeId\n    ".concat(EXTENSIONS_FRAGMENT, "\n    overrides\n    toastConfig {\n      position\n      size\n      isClosable\n      duration\n    }\n  }\n");
